{
  "watchVideo": "Regarder la vidéo",
  "listen": "Écouter",
  "openIn": "Ouvrir dans",
  "notFoundTitle": "Prédication introuvable",
  "notFoundDescription": "Nous n'avons pas trouvé cette prédication."
}
